/**
 * Stable identifiers for signup CTA analytics (`signup_cta_clicked.cta_id`).
 *
 * Keep values kebab-case and unique. Paid campaign claim buttons use
 * `campaign_cta_clicked` instead — do not reuse these IDs there.
 */

/** CTA id union for type-safe tracking. */
export type SignupCtaId =
  | typeof SIGNUP_CTA_IDS[keyof typeof SIGNUP_CTA_IDS];

/**
 * Canonical signup CTA ids.
 *
 * Business rule: every navigate to `/auth/signup` from a free/organic path
 * should pass one of these so GA4 can attribute which surface started signup.
 */
export const SIGNUP_CTA_IDS = {
  LandingHero: 'landing-hero',
  LandingFinal: 'landing-final',
  PublicNav: 'public-nav',
  PricingFree: 'pricing-free',
  PricingSubscribe: 'pricing-subscribe',
  CardsPage: 'cards-page',
  FlowersPage: 'flowers-page',
  MailedCardsPage: 'mailed-cards-page',
  GiftsPage: 'gifts-page',
  HowItWorks: 'how-it-works',
  Faq: 'faq',
  AutomatedOccasionGiftsGuide: 'automated-occasion-gifts-guide',
  AiHub: 'ai-hub',
  ExploreCards: 'explore-cards',
  GuestScheduleCard: 'guest-schedule-card',
  GuestFlowerOrder: 'guest-flower-order',
  GuestMailedCard: 'guest-mailed-card',
} as const;
